import { AutoWeighingService } from './../../../../legacy/auto-weighing/auto-weighing.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AppClientConfigurationService, SelectFieldOption, TranslationService } from '@sdbn/common';
import { WeighingResult } from '../../register-entrance-leave.model';

@Component({
  selector: 'app-weighing',
  templateUrl: './weighing.component.html',
  styleUrls: ['./weighing.component.scss']
})
export class WeighingComponent implements OnInit {

  @Input() usage: string;

  @Input() autoWeighingSource: string;

  @Output() validityChanged = new EventEmitter<boolean>();

  @Output() valueChanged = new EventEmitter<WeighingResult>();

  autoValue : number = null;
  autoSource : string = null;

  formGroup = new FormGroup({
    weight: new FormControl(null, []),
    weightUsage: new FormControl(null, [])
  });

  options = [
    new SelectFieldOption({ labelDictionaryKey: 'tmc.transport.register-entrance-combined.weighingType.BETWEEN', value: 'BETWEEN' }),
    new SelectFieldOption({ labelDictionaryKey: 'tmc.transport.register-entrance-combined.weighingType.EMPTY', value: 'EMPTY' }),
    new SelectFieldOption({ labelDictionaryKey: 'tmc.transport.register-entrance-combined.weighingType.FULL', value: 'FULL' })
  ];

  constructor(
    public translationService: TranslationService,
    private autoWeighingService: AutoWeighingService,
    public cps: AppClientConfigurationService,
  ) { }

  ngOnInit(): void {

    this.formGroup.patchValue({ weightUsage: this.usage });

    this.formGroup.valueChanges.subscribe(value => {

      this.valueChanged.next(new WeighingResult({
        weight: value.weight,
        source: value.weight === this.autoValue ? this.autoSource : null,
        usage: value.weightUsage
      }));

      this.validityChanged.next(value.weight > 0 && value.weight <= this.cps.getPropertyValue('ui-component.transport-details.weighing.max-weight', '50000'));

    });

  }

  public readWeight() {

    console.log('weighing result requested');

    this.autoWeighingService.readWeight(this.autoWeighingSource).subscribe(result => {

      this.autoValue = result.weight;
      this.autoSource = result.libra;

      this.formGroup.patchValue({ weight: result.weight });

    });

  }
  
  maxWeightExceeded() {
    return this.formGroup.controls.weight.value > this.cps.getPropertyValue('ui-component.transport-details.weighing.max-weight', '50000');
  }


}
